import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { PageHeader, Card } from "@/components/admin/common";
import { useAccounts } from "@/components/finance/shared";
import EntryForm from "@/components/finance/EntryForm";
import TransactionList from "@/components/finance/TransactionList";
import Reports from "@/components/finance/Reports";
import Accounts from "@/components/finance/Accounts";

const TABS = [["catat", "Catat Transaksi"], ["riwayat", "Riwayat"], ["laporan", "Laporan"], ["akun", "Daftar Akun"]];

export default function Finance() {
  const [params, setParams] = useSearchParams();
  const tab = params.get("tab") || "catat";
  const [accounts, reload] = useAccounts();
  const [taxMode, setTaxMode] = useState("umkm");
  useEffect(() => { api.get("/admin/settings").then((r) => setTaxMode(r.data.tax_mode || "umkm")); }, []);

  return (
    <div className="max-w-5xl" data-testid="finance-page">
      <PageHeader title="Keuangan" subtitle={`Catat uang masuk & keluar — pembukuan otomatis. Mode pajak: ${taxMode === "umkm" ? "UMKM PPh Final 0,5%" : "PPN & PPh (reguler)"}`} />
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-1 bg-white border border-border rounded-xl p-1 mb-5" data-testid="finance-tabs">
        {TABS.map(([k, l]) => (
          <button key={k} onClick={() => setParams({ tab: k })} data-testid={`finance-tab-${k}`}
            className={`px-2 h-11 rounded-lg text-sm font-bold whitespace-nowrap ${tab === k ? "bg-ocean text-white" : "text-slate-600"}`}>{l}</button>
        ))}
      </div>
      {tab === "catat" && <Card className="p-4 sm:p-6"><EntryForm accounts={accounts} taxMode={taxMode} /></Card>}
      {tab === "riwayat" && <TransactionList accounts={accounts} taxMode={taxMode} />}
      {tab === "laporan" && <Reports accounts={accounts} />}
      {tab === "akun" && <Accounts accounts={accounts} reload={reload} />}
    </div>
  );
}
